import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import RFG from "../../libs/inputs/RFG";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MultiSelect from "../extra/MultiSelect";
import CountrySelect from "../extra/CountrySelect";
import Alert from "@mui/material/Alert";

export default function Form({
  title,

  companies = [],
  projects = [],
  users = [],
  defaultValues = {},
  onSubmit = () => {},
  onChange = () => {},
  back = () => {},
}) {
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "all",
    shouldFocusError: true,
  });

  const [open, setOpen] = useState(false);
  const companyValue = watch("company");
  const isFirstRender = useRef(true);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    // only reset once on first load, not after every save
    if (isFirstRender.current && defaultValues) {
      reset(defaultValues);
      isFirstRender.current = false;
    }
  }, [defaultValues, reset]);
  // useEffect(() => {
  //   // Manually register the field and set default value
  //   register("project");
  //   setValue("project", defaultValues.projects || [], { shouldValidate: true });
  // }, [register, setValue, defaultValues.projects]);
  useEffect(() => {
    let pid = watch("project");
    let project = projects.filter((project) => {
      return pid == project.id;
    });
    setValue("error_email", project[0]?.error_email || "");
    console.log("project", project);
  }, [watch("project")]);

  useEffect(() => {
    onChange("company", companyValue);
    setValue("error_email", "");
  }, [companyValue]);

  useEffect(() => {
    let pid = watch("project");
    let project = projects.filter((project) => {
      return pid == project.id;
    });
    setValue("error_email", project[0]?.error_email || "");
    console.log("project", project);
  }, [watch("project")]);

  // const handleFormSubmit = (data) => {
  //   console.log("data submit", data);
  //   const proj = data.project || [];
  //   if (!proj.length) {
  //     setError("project", {
  //       type: "required",
  //       // message: "Please select at least one project",
  //     });
  //     return; // stop submission
  //   }
  //   onSubmit(data);
  //   reset({
  //     company: "",
  //     project: "",
  //     error_email: "",
  //   });
  // };

  const handleFormSubmit = async (data) => {
    console.log("data submit", data);
    const proj = data.project || [];
    if (!proj.length) {
      setError("project", { type: "required" });
      return;
    }
    try {
      onSubmit(data); // wait for parent handler if it’s async
      setSuccessMsg("Data saved successfully!"); // show message

      // auto-hide after 3 seconds
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      console.error("Save failed:", err);
      setSuccessMsg("Failed to save data. Please try again.");
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  return (
    <Box sx={{ pb: 2 }}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <RFG
              name="company"
              label="Company"
              control={control}
              rules={{ required: true }}
              className="mb-2"
            >
              <select>
                <option value="">Select Company</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.company_name}
                  </option>
                ))}
              </select>
            </RFG>
            <RFG
              name="project"
              label="Project Name"
              control={control}
              rules={{ required: true }}
              className="mb-2"
            >
              <select
                onChange={(e) => {
                  alert(e.target.getAttribute("data-emails"));
                }}
              >
                <option value="">Select Project</option>
                {projects.map((project) => (
                  <option
                    key={project.id}
                    value={project.id}
                    data-emails={project.error_email}
                  >
                    {project.project_name}
                  </option>
                ))}
              </select>
            </RFG>
            <RFG
              name="error_email"
              label="Email Ids (separated by comma)"
              control={control}
              rules={{
                required: true,
                maxLength: 500,
                pattern: {
                  value:
                    /^([\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})(\s*,\s*[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})*$/,
                  message: "Enter a valid emails ",
                },
              }}
              className="mb-2"
              error={errors.project?.message}
            >
              <textarea className="input" style={{ width: "100%" }}></textarea>
            </RFG>

            <Box textAlign="right" sx={{ my: 2 }}>
              <Button
                onClick={() => setValue("action", "info")}
                className="btn-primary"
                type="submit"
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
        {successMsg && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMsg}
          </Alert>
        )}
      </form>
    </Box>
  );
}
